<template>
    <section class="app-main">
        <div class="router-view-container">
            <!-- <keep-alive> -->
            <!-- 需要缓存的视图组件 -->
            <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
            <!-- </keep-alive> -->
            <!-- 不需要缓存的视图组件 -->
            <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
            <router-view></router-view>
        </div>
    </section>
</template>

<script>
export default {
    name: "AppMain",
};
</script>

<style scoped>
.app-main {
    /*50 = navbar  */
    height: calc(100vh);
    width: 100%;
    position: relative;
    background-color: #F8F9FA;
    /* padding: 16px; */
}
.app-main .router-view-container {
    background-color: #fff;
    /* min-height: calc(100vh - 50px - 32px); */
    height: 100%;
    /* box-shadow: 0px 4px 8px 0px rgba(18, 43, 130, 0.1); */
}
.app-main::-webkit-scrollbar{
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
}
.router-view-container::-webkit-scrollbar{
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
}
.fixed-header + .app-main {
    padding-top: calc(50px + 16px);
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
    .fixed-header {
        padding-right: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue